/**
 * local调试内容
 */
export default {
  //构建内容
  build() {
    return [
      {
        title: 'back-debug',//后端调试
        content: [{
          name: 'local-debug-whaee-v2console',//哇鹅-商家端v2控制台
          id: 1,
          link: 'http://local.console.whaee.net/v2/login',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content_local_debug.js